// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  handleClearButton: () => void,
|};

export const ClearButton = ({ handleClearButton }: Props) => (
  <Box>
    <Box display="flex" alignItems="center" justifyContent="between">
      <Box minWidth={0} width="100%">
        <Text weight="bold">
          {i18n._('Filters', 'Header of product group drawer containing filter options')}
        </Text>{' '}
      </Box>
      <Box flex="none" data-test-id="clear-button">
        <Button
          text={i18n._('Clear', 'Button to clear all set filters on product group filters')}
          size="sm"
          onClick={() => handleClearButton()}
        />
      </Box>
    </Box>
  </Box>
);

export default ClearButton;
